import Flickity from "flickity";
require('flickity-fade');

export default () => ({
    carousel: null,
    carouselTimeout: 5000,
    carouselRefreshInterval: null,
    buttons: [],

    init() {
        this.carousel = new Flickity(this.$el.querySelector('.image-carousel-instance'), {
            timeout: this.carouselTimeout,
            draggable: false,
            adaptiveHeight: true,
            pageDots: false,
            pauseAutoPlayOnHover: false,
            navigation: false,
            fade: true,
            wrapAround: true
        });

        this.buttons = this.$el.querySelectorAll('.button');

        if (this.buttons.length > 0) {
            this.handleCarouselTimerButton();

            this.carousel.on('select', (index) => {
                if (this.carouselRefreshInterval !== null) {
                    clearInterval(this.carouselRefreshInterval);
                }

                this.buttons.forEach((button, index) => {
                    if (index === this.carousel.selectedIndex) {
                        button.classList.add('active');
                        button.querySelector('circle').style.strokeDashoffset = '300px';
                    } else {
                        button.classList.remove('active');
                    }
                });

                this.handleCarouselTimerButton();
            });
        }
    },

    handleClick(index) {
        this.carousel.select(index);
        this.carousel.reposition();
    },

    handleCarouselTimerButton() {
        if (this.carouselRefreshInterval !== null) {
            clearInterval(this.carouselRefreshInterval);
        }

        let offset = 300;
        const intervalDuration = this.carouselTimeout / offset;

        this.carouselRefreshInterval = setInterval(() => {
            offset--;

            const currentButton = this.buttons[this.carousel.selectedIndex];
            if (!currentButton) return;

            const diamondWhiteBorder
                = currentButton.querySelector('.diamond-active-border');
            if (diamondWhiteBorder) {
                diamondWhiteBorder.style.strokeDashoffset = `${offset}px`;
            }

            if (offset <= 1) {
                clearInterval(this.carouselRefreshInterval);
                this.carouselRefreshInterval = null;
                this.carousel.next(false, false);
            }
        }, intervalDuration);
    },
});